import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchUserRoles,
  assignRoleToUser,
  removeRoleFromUser,
} from '../api/rbacApi';

// ⬇️ import from the new Users API (single source of truth)
import { fetchUsers, type User } from '../../user/api/usersApi';

export function useUsersRoles() {
  const qc = useQueryClient();

  const users = useQuery<User[], Error>({
    queryKey : ['rbac', 'users'],
    queryFn  : () => fetchUsers(),
    staleTime: 60_000,
  });

  const assign = useMutation({
    mutationFn : (p: { uid: number; role: string }) =>
      assignRoleToUser(p.uid, p.role),
    onSuccess  : (_res, { uid }) =>
      qc.invalidateQueries({ queryKey: ['rbac', 'userRoles', uid] }),
  });

  const remove = useMutation({
    mutationFn : (p: { uid: number; role: string }) =>
      removeRoleFromUser(p.uid, p.role),
    onSuccess  : (_res, { uid }) =>
      qc.invalidateQueries({ queryKey: ['rbac', 'userRoles', uid] }),
  });

  return { users, assign, remove };
}

export function useRolesForUser(uid: number) {
  return useQuery<string[], Error>({
    queryKey : ['rbac', 'userRoles', uid],
    queryFn  : () => fetchUserRoles(uid),
    enabled  : !!uid,
    staleTime: 30_000,
  });
}
